import React from 'react';
import { Container } from 'react-bootstrap';

const Projects = () => {
    return (
        <div>
            <Container>
            <h1>Projects</h1>

            </Container>
        </div>
    );
};

export default Projects;